import { DoneOutlineIcon } from '@assets/icons';
import { Typography, Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './DriverRegister.scss';

const DriverRegisterSuccess: FC = () => {
  const { t } = useTranslation();
  return (
    <Box className='driverRegisterSuccessContainer'>
      <Typography className='headerTypography' variant='h4'>
        {t('driver_register.reception_management_system')}
      </Typography>

      <DoneOutlineIcon className='doneOutlineIcon' />

      <Typography variant='body1' className='titleRegisterSuccess'>
        {t('driver_register.register_success')}
      </Typography>
    </Box>
  );
};

export default DriverRegisterSuccess;
